import { HarvestProofAnswer } from '@harvest-proof/data-access';

export interface AnswerCaptureMetadataLabels {
  receivedAt: string;
  gps: string;
  heading: string;
  unavailable: string;
}

export function parseCoordinate(
  value: string | null | undefined,
): number | null {
  if (value == null || value === '') {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatAnswerCaptureMetadataLines(
  answer: Pick<
    HarvestProofAnswer,
    'latitude' | 'longitude' | 'device_heading' | 'server_submitted_at'
  >,
  labels: AnswerCaptureMetadataLabels,
  formatReceivedAt: (iso: string) => string,
): string[] {
  const lines: string[] = [];

  if (answer.server_submitted_at) {
    lines.push(
      `${labels.receivedAt}: ${formatReceivedAt(answer.server_submitted_at)}`,
    );
  }

  const latitude = parseCoordinate(answer.latitude);
  const longitude = parseCoordinate(answer.longitude);

  if (latitude != null && longitude != null) {
    lines.push(`${labels.gps}: ${latitude.toFixed(5)}, ${longitude.toFixed(5)}`);
  }

  if (answer.device_heading != null) {
    lines.push(`${labels.heading}: ${Math.round(answer.device_heading)}°`);
  } else if (latitude != null && longitude != null) {
    lines.push(`${labels.heading}: ${labels.unavailable}`);
  }

  return lines;
}

export function getAnswerCaptureCoordinates(
  answer: Pick<HarvestProofAnswer, 'latitude' | 'longitude'>,
): { latitude: number; longitude: number } | null {
  const latitude = parseCoordinate(answer.latitude);
  const longitude = parseCoordinate(answer.longitude);

  if (latitude == null || longitude == null) {
    return null;
  }

  return { latitude, longitude };
}
